export default __webpack_public_path__ + "static/media/2011-IMcover.5475fb2c.jpg";